<template>
	<mescroll-vue
		ref="mescroll"
		:down="mescrollDown"
		:up="mescrollUp"
		@init="mescrollInit"
		:class="{ 'mescroll-responsive': isStaff }"
	>
		<div class="job-list">
			<div class="job-list-header">
				<h2 class="job-list-title">Job Listing</h2>
				<BaseSearch
					class="job-list-header-search"
					v-model="searchParams"
					v-if="isStaff"
					:buttonClick="searchJobs"
				/>
			</div>

			<div class="job-list-active-tab">
				<BaseTab :changeActiveTab="changeActiveTab"/>
				<div
					class="custom-control custom-checkbox custom-control-inline checkbox"
					v-if="isStaff && this.activeTab !== 'new'"
				>
					<input
						type="checkbox"
						class="custom-control-input"
						id="defaultInline1"
						@click="activeTabCheckBoxClick"
						:checked="isShowMyJob"
					>
					<label class="custom-control-label checkbox-color-primary" for="defaultInline1">Only My Jobs</label>
				</div>
			</div>
			<div class="job-list-index">
				<span>Sort By:</span>
				<BaseSelect :options="sortOptions" v-model="sortValue" @change="changeSort"/>
			</div>
			<JobCard v-for="job in jobs" :key="job.job_id" :job="job"/>
			<div id="no-data"></div>
			<div class="to-top-wrapper" @click.prevent="toTop" v-if="isScrollY">
				<mdb-icon icon="arrow-up" class="to-top-icon"/>
			</div>
		</div>
	</mescroll-vue>
</template>

<script>
import JobCard from '@/components/JobCard.vue'
import { mapState } from 'vuex'
import NProgress from 'nprogress'
import MescrollVue from 'mescroll.js/mescroll.vue'
import { isStaff } from '@/utils/Help.js'
import { mdbIcon } from 'mdbvue'

export default {
	name: 'JobList',
	data() {
		return {
			sortOptions: [
				'Run Date',
				'Unread First',
				'Placed Time',
				'Deadline'
			],
			isScrollY: false,
			sortValue: 'Run Date',
			searchParams: {
				type: 'Client Email',
				content: ''
			},
			mescroll: null, // mescroll实例对象
			mescrollDown: {
				use: false
			}, //下拉刷新的配置. (如果下拉刷新和上拉加载处理的逻辑是一样的,则mescrollDown可不用写

			mescrollUp: {
				// 上拉加载的配置
				callback: this.upCallback, // 上拉回调,此处可简写; 相当于 callback: function (page, mescroll) { getListData(page); }
				//以下是一些常用的配置,当然不写也可以的.
				page: {
					num: 0, //当前页 默认0,回调之前会加1; 即callback(page)会从1
					size: 5 //每页数据条数,默认10
				},
				htmlLoading:
					'<p class="upwarp-progress mescroll-rotate"></p><p class="upwarp-tip">Loading..</p>',
				htmlNodata: '<p class="upwarp-nodata"> - END - </p>',
				noMoreSize: 5, //如果列表已无数据,可设置列表总数大于5才显示无更多数据;避免列表数据过少(比如只有一条数据),显示无更多数据会不好看
				empty: {
					//列表第一页无任何数据时,显示的空提示布局; 需配置warpId才显示
					// warpId: 'no-data', //父布局的id (1.3.5版本支持传入dom元素)
					// icon: null, //图标,默认null,支持
					// tip: 'Unfortunately, no results found.' //
				}
			},
			dataList: [],
			isStaff: isStaff()
		}
	},
	mounted() {
		this.$store.dispatch('job/clearJobs')
	},
	activated() {
		window.addEventListener('scroll', this.handleTriggerUpScroll)
		this.isStaff = isStaff()
	},
	deactivated() {
		window.removeEventListener('scroll', this.handleTriggerUpScroll)
	},
	components: {
		JobCard,
		MescrollVue,
		mdbIcon
	},
	computed: {
		...mapState({
			jobs: state => state.job.jobs,
			activeTab: state => state.job.activeTab,
			isShowMyJob: state => state.job.isShowMyJob,
			sortBy: state => state.job.sortBy,
			isLoading: state => state.job.isLoading
		}),
		jobsCount() {
			return this.jobs && this.jobs.length
		}
		// isStaff() {
		// 	return isStaff()
		// }
	},
	methods: {
		// mescroll组件初始化的回调,可获取到mescroll对象 (如果this.mescroll并没有使用到,可用mescrollI
		mescrollInit(mescroll) {
			this.mescroll = mescroll
		},
		// 上拉回调 page = {num:1, size:10};
		async upCallback(page, mescroll) {
			let jobs = await this.getJobs()
			this.$nextTick(() => {
				mescroll.endSuccess(jobs.length)
			})
		},
		async changeActiveTab() {
			if (!this.isLoading) {
				this.$store.dispatch('job/clearJobs')
				await this.getJobs()
			}
		},
		toTop() {
			document.body.scrollTop = document.documentElement.scrollTop = 0
		},
		async handleTriggerUpScroll() {
			let scrollHeight = document.body.scrollHeight
			let scrollY = window.scrollY

			let clientHeight = document.body.clientHeight
			let restHeight = scrollHeight - clientHeight - scrollY
			// console.log(scrollHeight, scrollY, clientHeight, restHeight)
			if (restHeight < 10 && scrollY > 0) {
				// this.$store.dispatch('job/setPrevScrollY', {
				// 	scrollY
				// })
				this.mescroll.triggerUpScroll()
			}
			if (scrollY > 0) {
				this.isScrollY = true
			} else {
				this.isScrollY = false
			}
		},
		async changeSort() {
			if (!this.isLoading) {
				let sortBy
				const sortValue = this.sortValue
				if (sortValue === 'Placed Time') {
					sortBy = 'timestamp'
				} else if (sortValue === 'Deadline') {
					sortBy = 'deadline'
				} else if (sortValue === 'Run Date') {
					sortBy = 'rundate'
				} else {
					sortBy = 'unreadposts'
				}
				this.$store.dispatch('job/setSortBy', {
					sortBy
				})
				this.$store.dispatch('job/clearJobs')
				await this.getJobs()
			}
		},
		async searchJobs() {
			if (!this.isLoading) {
				if (
					this.searchParams.type === 'Job Id' &&
					this.searchParams.content
				) {
					try {
						NProgress.start()
						const job_id = this.searchParams.content.trim()
						const job = await this.$store.dispatch('job/getJob', {
							job_id
						})
						if (job) {
							this.$router.push({
								name: 'job-details',
								params: { job_id }
							})
							this.searchParams = {
								type: 'Client Email',
								content: ''
							}
						} else {
							NProgress.done()
							this.$store.dispatch('job/clearJobs')
							const notification = {
								type: 'error',
								message: `Oops! This Job is not found.`
							}
							this.$store.dispatch(
								'notification/add',
								notification,
								{
									root: true
								}
							)
							// this.searchParams = {
							// 	type: 'Job Id',
							// 	content: ''
							// }
						}
					} catch (e) {
						NProgress.done()
						console.log(e)
					}
				} else {
					this.$store.dispatch('job/clearJobs')
					await this.getJobs()
				}
			}
		},
		async activeTabCheckBoxClick(e) {
			if (!this.isLoading) {
				const isShowMyJob = e.target.checked
				this.$store.dispatch('job/setIsShowMyJob', {
					isShowMyJob
				})
				this.$store.dispatch('job/clearJobs')
				await this.getJobs()
			}
		},
		async getJobs() {
			let job_status = this.activeTab
			let pageSize = 15
			let sortBy = this.sortBy
			let exclusiveStartKey = JSON.stringify({})
			let user = JSON.parse(sessionStorage.getItem('user'))
			let profile = user.profile
			let lastjob = this.jobs[this.jobsCount - 1]

			const staffAllSortBy = (
				exclusiveStartKey,
				sortBy,
				job_id,
				query_type,
				create_time_stamp,
				deadline,
				unread_client_posts,
				run_date
			) => {
				switch (sortBy) {
					case 'timestamp':
						exclusiveStartKey = JSON.stringify({
							job_id,
							query_type,
							create_time_stamp
						})
						break
					case 'deadline':
						exclusiveStartKey = JSON.stringify({
							job_id,
							query_type,
							deadline
						})
						break
					case 'unreadposts':
						exclusiveStartKey = JSON.stringify({
							job_id,
							query_type,
							unread_client_posts
						})
						break
					case 'rundate':
						exclusiveStartKey = JSON.stringify({
							job_id,
							query_type,
							run_date
						})
						break
				}
				return exclusiveStartKey
			}

			const staffOwnedSortBy = (
				exclusiveStartKey,
				sortBy,
				job_id,
				staff_email,
				create_time_stamp,
				deadline,
				unread_client_posts,
				run_date
			) => {
				switch (sortBy) {
					case 'timestamp':
						exclusiveStartKey = JSON.stringify({
							job_id,
							staff_email,
							create_time_stamp
						})
						break
					case 'deadline':
						exclusiveStartKey = JSON.stringify({
							job_id,
							staff_email,
							deadline
						})
						break
					case 'rundate':
						exclusiveStartKey = JSON.stringify({
							job_id,
							staff_email,
							run_date
						})
						break
					case 'unreadposts':
						exclusiveStartKey = JSON.stringify({
							job_id,
							staff_email,
							unread_client_posts
						})
						break
				}
				return exclusiveStartKey
			}

			if (lastjob) {
				const {
					job_id,
					staff_email,
					create_time_stamp,
					query_type,
					client_email,
					deadline,
					unread_client_posts,
					unread_staff_posts,
					run_date
				} = lastjob
				switch (profile) {
					case 'Staff':
						switch (job_status) {
							case 'new':
								exclusiveStartKey = staffAllSortBy(
									exclusiveStartKey,
									sortBy,
									job_id,
									query_type,
									create_time_stamp,
									deadline,
									unread_client_posts,
									run_date
								)
								break
							case 'processing':
								switch (this.isShowMyJob) {
									case false:
										exclusiveStartKey = staffAllSortBy(
											exclusiveStartKey,
											sortBy,
											job_id,
											query_type,
											create_time_stamp,
											deadline,
											unread_client_posts,
											run_date
										)
										break
									default:
										exclusiveStartKey = staffOwnedSortBy(
											exclusiveStartKey,
											sortBy,
											job_id,
											staff_email,
											create_time_stamp,
											deadline,
											unread_client_posts,
											run_date
										)
								}
								break
							case 'approved':
								switch (this.isShowMyJob) {
									case false:
										exclusiveStartKey = staffAllSortBy(
											exclusiveStartKey,
											sortBy,
											job_id,
											query_type,
											create_time_stamp,
											deadline,
											unread_client_posts,
											run_date
										)
										break
									default:
										exclusiveStartKey = staffOwnedSortBy(
											exclusiveStartKey,
											sortBy,
											job_id,
											staff_email,
											create_time_stamp,
											deadline,
											unread_client_posts,
											run_date
										)
								}
								break
							case 'completed':
								switch (this.isShowMyJob) {
									case false:
										exclusiveStartKey = staffAllSortBy(
											exclusiveStartKey,
											sortBy,
											job_id,
											query_type,
											create_time_stamp,
											deadline,
											unread_client_posts,
											run_date
										)
										break
									default:
										exclusiveStartKey = staffOwnedSortBy(
											exclusiveStartKey,
											sortBy,
											job_id,
											staff_email,
											create_time_stamp,
											deadline,
											unread_client_posts,
											run_date
										)
								}
						}
						break
					case 'Client':
						switch (sortBy) {
							case 'timestamp':
								exclusiveStartKey = JSON.stringify({
									job_id,
									client_email,
									create_time_stamp
								})
								break
							case 'deadline':
								exclusiveStartKey = JSON.stringify({
									job_id,
									client_email,
									deadline
								})
								break
							case 'rundate':
								exclusiveStartKey = JSON.stringify({
									job_id,
									client_email,
									run_date
								})
								break
							case 'unreadposts':
								exclusiveStartKey = JSON.stringify({
									job_id,
									client_email,
									unread_staff_posts
								})
								break
						}
						break
				}
			}

			NProgress.start()
			const query_type =
				this.isShowMyJob && job_status !== 'new' ? 'owned' : 'jobspool'
			let jobs

			const contentForSearch = this.searchParams.content.trim()
			const typeForSearch = this.searchParams.type
			if (!contentForSearch) {
				jobs = await this.$store.dispatch('job/fetchJobs', {
					job_status,
					query_type,
					pageSize,
					sortBy,
					exclusiveStartKey
				})
			} else {
				if (typeForSearch === 'Client Email') {
					jobs = await this.$store.dispatch(
						'job/searchJobsByClientEmail',
						{
							client_email: contentForSearch,
							job_status,
							query_type,
							pageSize,
							sortBy,
							exclusiveStartKey
						}
					)
				} else if (typeForSearch === 'Booking Number') {
					jobs = await this.$store.dispatch(
						'job/searchJobsByBookingNumber',
						{
							booking_number: contentForSearch,
							job_status,
							query_type,
							pageSize,
							sortBy,
							exclusiveStartKey
						}
					)
				} else {
					jobs = await this.$store.dispatch(
						'job/searchJobsByJobTitle',
						{
							job_title: contentForSearch,
							job_status,
							query_type,
							pageSize,
							sortBy,
							exclusiveStartKey
						}
					)
				}
			}

			NProgress.done()
			return jobs
		}
	}
}
</script>

<style lang="scss" scoped>
@import '../styles/views/jobList.scss';
</style>
